import React from 'react'

import { Icon } from '@app/components/util'

import type { ReactNode } from 'react'
import type { IconProps } from '@app/components/util/Icon/types'

export const getMenuIcon = (iconProps?: IconProps): ReactNode => {
  if (!iconProps) return

  return <Icon { ...iconProps } />
}
